import React from 'react';
import './FooterOverlay.scss';

const FooterOverlay = () => {
  return (
    <div className='app-footerOverlay '>
      <div className='black' />
      <div className='img app__bg' />
    </div>
  )
}

export default FooterOverlay
